import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, AfterViewInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { RoomDetailService } from '../../room-detail.service';

@Component({
  selector: 'app-chat-visual-editor',
  templateUrl: './chat-visual-editor.component.html',
  styleUrls: ['./chat-visual-editor.component.scss'],
})
export class ChatVisualEditorComponent {
  visual: any = {
    backgroundColor: '#ffffff',
    headerBackgroundColor: '#eeeeee',
    headerBotUrl: null,
    headerText: 'Asistente Virtual',
    headerTextColor: '#000000',
    botBubbleColor: '#444444',
    botTextColor: '#ffffff',
    userBubbleColor: '#e2ae2f',
    userTextColor: '#000000',
    inputBackgroundColor: '#f9f9f9',
    inputTextColor: '#333333',
    sendButtonColor: '#e2ae2f',
    sendIconColor: '#ffffff',
    closeButtonColor: '#e65c2e',
    closeIconColor: '#ffffff',

    fontFamily: 'Arial, sans-serif',
    fontSize: '14px',
    headerFontSize: '16px',
    headerFontWeight: 'bold',

    showBotAvatar: true,
    botAvatarUrl: null,
    bubbleBorderRadius: '16px',
    chatBorderRadius: '16px',

    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
    bubblePadding: '10px 14px',
    chatWidth: '395px',
    laucherColor: '#e2ae2f',
  };

  selectedLauncherFile: File | null = null;
  selectedAvatarFile: File | null = null;
  MAX_IMAGE_SIZE_KB = 100;
  ALLOWED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp'];

  imageErrors = {
    launcher: null as string | null,
    avatar: null as string | null,
  };

  constructor(
    public matDialogRef: MatDialogRef<ChatVisualEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _roomDetailService: RoomDetailService
  ) {
    if (data.action) {
      this._roomDetailService
        .getChatWebStyleConfig(data.room.appSecretPass)
        .subscribe(resp => {
          this.visual = resp;
          if (this.visual.headerText == null) {
            this.visual.headerText = 'Asistente Virtual';
          }
        });
    }
  }

  onLauncherImageSelected(event: Event): void {
    this.handleImageSelection(event, 'launcher');
  }

  onAvatarImageSelected(event: Event): void {
    this.handleImageSelection(event, 'avatar');
  }

  private handleImageSelection(event: Event, type: 'launcher' | 'avatar'): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];

    // Validar tipo MIME
    if (!this.ALLOWED_IMAGE_TYPES.includes(file.type)) {
      this.imageErrors[type] =
        'Formato no soportado. Solo se permiten PNG, JPEG o WebP.';
      return;
    }

    // Validar tamaño
    const fileSizeKB = file.size / 1024;
    if (fileSizeKB > this.MAX_IMAGE_SIZE_KB) {
      this.imageErrors[type] =
        `La imagen debe pesar menos de ${this.MAX_IMAGE_SIZE_KB} KB.`;
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const width = img.width;
        const height = img.height;

        // Validar dimensiones
        if (width < 32 || height < 32) {
          this.imageErrors[type] =
            'La imagen es demasiado pequeña. Debe tener al menos 32x32 píxeles.';
          return;
        }

        // Si todo va bien, se borra el error
        this.imageErrors[type] = null;

        if (type === 'launcher') {
          this.selectedLauncherFile = file;
          this.visual.botAvatarUrl = reader.result as string;
        } else {
          this.selectedAvatarFile = file;
          this.visual.headerBotUrl = reader.result as string;
        }
      };
      img.src = reader.result as string;
    };

    reader.readAsDataURL(file);
  }
}
